const splitFileName = (fileName: string) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    const name = fileName.slice(0, lastDotIndex);
    const extension = fileName.slice(lastDotIndex + 1);

    return { name, extension };
};

export default splitFileName;
